<template>
  <v-container v-if="currentForm && teams[$route.params.team].account">
    <v-row>
      <v-col stretch>
        <v-breadcrumb class="justify-between flex-wrap" :items="breadcrumbFormItems" :mobile="breadcrumbMobileItem">
          <v2-search
            :placeholder="$t('settings.forms.placeholders.search')"
            maxWidth
            @reset="search('formSubmissions', getSubmissions)"
            @submit="search('formSubmissions', getSubmissions)"
            v-model="searchQuery"
          ></v2-search>
        </v-breadcrumb>
      </v-col>
    </v-row>
    <v-row>
      <v-col stretch>
        <v-title-bar
          :title="
            $t('settings.forms.titles.submissionOf', {
              form: currentForm.name,
            })
          "
        >
        </v-title-bar>
      </v-col>
    </v-row>
    <v-row v-if="formSubmissions">
      <v-col class="col-12 p-0">
        <v-list-header complex>
          <v-list-header-cell
            size="2"
            :showAs="$t('settings.forms.labels.submissionDate')"
            :showAsDropdownUid="$h.createUniqueUid()"
            :showAsDropdown="sortMainColDropdown"
          />
          <v-list-header-cell :title="$t('settings.forms.labels.project')" />
          <v-list-header-cell :title="$t('settings.forms.labels.client')" />
          <v-list-header-cell
            :mobile="$t('actions.sort')"
            :mobileDropdownUid="$h.createUniqueUid()"
            :mobileDropdown="mobileDropdown"
          />
          <v-list-header-cell
            filter
            dropdownRight
            multiselect
            :filterActive="teamsSettings[$route.params.team].listsSettings.formSubmissions.filterActive"
            :filterDropdownUid="$h.createUniqueUid()"
            :filterDropdown="filterDropdown"
          />
        </v-list-header>
        <ul class="list" v-if="formSubmissions">
          <router-link
            :to="{
              name: 'FormSubmission',
              params: {
                form: $route.params.uid,
                submission: submission.uid,
              },
            }"
            v-for="submission in formSubmissions"
            :key="submission.uid"
          >
            <v-list-item complex hover>
              <v-list-cell
                :title="$h.formatDate(submission.created_at, teams[$route.params.team].account.timezone)"
                size="2"
                :mobileSubtitle="submission.project_title + ' - ' + submission.client_name"
              />
              <v-list-cell :value="submission.project_title" />
              <v-list-cell :value="submission.client_name" />
              <v-list-cell emptyIcon></v-list-cell>
              <!--              <v-list-cell-->
              <!--                iconDropdown-->
              <!--                grey-->
              <!--                icon="more"-->
              <!--                :dropdownData="moreDropdown"-->
              <!--                :dropdownUid="$h.createUniqueUid()"-->
              <!--                :dropdownValue="submission.uid"-->
              <!--              />-->
            </v-list-item>
          </router-link>
          <v-list-item v-if="!(formSubmissions && formSubmissions.length)">
            <v-list-cell :value="$t('placeholders.noFormSubmissions')"></v-list-cell>
          </v-list-item>
        </ul>
        <v-list-pagination
          :currentPage="teamsSettings[$route.params.team].listsSettings.formSubmissions.pagination.page"
          :totalPages="teamsSettings[$route.params.team].listsSettings.formSubmissions.pagination.lastPage"
          :showPerPage="teamsSettings[$route.params.team].listsSettings.formSubmissions.pagination.perPage"
          :apiCall="
            (page, perPage) => {
              changeFormSubmissionsPage(page, perPage);
            }
          "
        >
        </v-list-pagination>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import listSettings from "@/mixins/listSettings.js";
import forms from "@/mixins/dropdowns/forms.js";

export default {
  name: "Form",
  mixins: [listSettings, forms],
  data() {
    return {
      searchQuery: "",
      moreDropdown: [],
      breadcrumbFormItems: [
        {
          label: this.$t("menus.settings"),
          route: { name: "Settings", params: { tab: "account" } },
        },
        {
          label: this.$t("menus.forms"),
          route: { name: "Settings", params: { tab: "forms" } },
        },
      ],
      breadcrumbMobileItem: {
        label: this.$t("menus.forms"),
        route: { name: "Settings", params: { tab: "forms" } },
      },
    };
  },
  created() {
    if (
      this.teamsSettings[this.$route.params.team] &&
      this.teamsSettings[this.$route.params.team].listsSettings.formSubmissions.search
    ) {
      this.searchQuery = this.teamsSettings[this.$route.params.team].listsSettings.formSubmissions.search;
    }
    this.filterDropdown = this.formSubmissionsDropdownData.filterDropdown;
    this.mobileDropdown = this.formSubmissionsDropdownData.mobileDropdown;
    this.sortMainColDropdown = this.formSubmissionsDropdownData.sortMainColDropdown;
    this.loadPageData();
  },
  beforeDestroy() {
    this.$store.commit("FORMS_RESET_FORM_SUBMISSIONS");
  },
  methods: {
    ...mapActions([
      "getFormSubmissions",
      "getProjectList",
      "getClientList",
      "getForm",
      "getFormSubmissionsProjects",
      "getFormSubmissionsClients",
    ]),
    loadPageData() {
      const vm = this;
      vm.$store.commit("GLOBAL_CUSTOM_LOADING_STARTED");
      vm.getForm({
        formFieldset: vm.$route.params.uid,
        customLoading: true,
      }).then(() => {
        vm.breadcrumbFormItems.push({
          label: vm.currentForm.name,
          active: true,
        });
      });
      let p = {
        search: vm.teamsSettings[vm.$route.params.team].listsSettings.formSubmissions.search,
        page: vm.teamsSettings[vm.$route.params.team].listsSettings.formSubmissions.pagination.page,
        per_page: vm.teamsSettings[vm.$route.params.team].listsSettings.formSubmissions.pagination.perPage,
        order_col: vm.teamsSettings[vm.$route.params.team].listsSettings.formSubmissions.order.col,
        order_dir: vm.teamsSettings[vm.$route.params.team].listsSettings.formSubmissions.order.dir,
        client: vm.teamsSettings[vm.$route.params.team].listsSettings.formSubmissions.filter.client.model,
        project: vm.teamsSettings[vm.$route.params.team].listsSettings.formSubmissions.filter.project.model,
      };
      let params = vm.setFilterRequestObjectFromStore("formSubmissions", p);
      const p1 = vm.getFormSubmissions({
        formFieldset: vm.$route.params.uid,
        setListsSettings: true,
        customLoading: true,
        params,
      });
      params = {
        per_page: "1000",
        order_col: "last_name",
        order_dir: "ASC",
        search: "",
      };
      const p2 = vm.getFormSubmissionsClients({
        params,
        customLoading: true,
        formFieldset: vm.$route.params.uid,
      });
      params = {
        per_page: "1000",
        order_col: "title",
        order_dir: "ASC",
        search: "",
      };
      const p3 = vm.getFormSubmissionsProjects({
        params,
        customLoading: true,
        formFieldset: vm.$route.params.uid,
      });
      Promise.all([p1, p2, p3])
        .then(() => {
          vm.initSort("formSubmissions");
          vm.initFilters("formSubmissions");
          vm.setDropdownOptions();
          vm.$store.commit("GLOBAL_CUSTOM_LOADING_ENDED");
        })
        .catch((err) => {
          console.log(err);
          vm.$store.commit("GLOBAL_CUSTOM_LOADING_ENDED");
        });
    },
    sortFormSubmissions(col, dir) {
      const params = {
        search: this.searchQuery,
        page: this.teamsSettings[this.$route.params.team].listsSettings.formSubmissions.pagination.page,
        per_page: this.teamsSettings[this.$route.params.team].listsSettings.formSubmissions.pagination.perPage,
        order_col: col,
        order_dir: dir,
      };
      this.getSubmissions(params);
    },
    changeFormSubmissionsPage(page, perPage) {
      const params = {
        search: this.searchQuery,
        page,
        per_page: perPage,
        order_col: this.teamsSettings[this.$route.params.team].listsSettings.formSubmissions.order.col,
        order_dir: this.teamsSettings[this.$route.params.team].listsSettings.formSubmissions.order.dir,
      };
      this.getSubmissions(params);
    },
    setFormSubmissionsFilters() {
      const params = {
        search: this.searchQuery,
        page: 1,
        per_page: this.teamsSettings[this.$route.params.team].listsSettings.formSubmissions.pagination.perPage,
        order_col: this.teamsSettings[this.$route.params.team].listsSettings.formSubmissions.order.col,
        order_dir: this.teamsSettings[this.$route.params.team].listsSettings.formSubmissions.order.dir,
      };
      this.getSubmissions(params);
      this.$eventbus.$emit("closeAllDropdowns");
    },
    getSubmissions(params) {
      this.filterDropdown[0].options.forEach((option) => {
        if (option.active && option.switch && option.switch.name && !option.select) {
          params[option.switch.name] = option.switch.model;
        }
        if (option.active && option.select && !option.select.custom) {
          params[option.select.name] = this.transformModelToRequestArray(option.select.model);
        }
      });
      this.getFormSubmissions({
        formFieldset: this.$route.params.uid,
        setListsSettings: true,
        params,
      }).then(() => {
        this.initSort("formSubmissions");
      });
    },
  },
  computed: {
    ...mapGetters({
      teams: "auth_get_teams",
      teamsSettings: "global_get_teams_settings",
      currentForm: "forms_get_current_form",
      formSubmissions: "forms_get_form_submissions",
      clients: "forms_get_current_form_submissions_clients",
      projects: "forms_get_current_form_submissions_projects",
    }),
  },
};
</script>
